import { render, staticRenderFns } from "./AwsMailIntegration.vue?vue&type=template&id=9383d2be&scoped=true"
import script from "./AwsMailIntegration.vue?vue&type=script&lang=js"
export * from "./AwsMailIntegration.vue?vue&type=script&lang=js"
import style0 from "./AwsMailIntegration.vue?vue&type=style&index=0&id=9383d2be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9383d2be",
  null
  
)

export default component.exports